/**
 * FeaturesProvider — thin passthrough; feature state lives in BootstrapProvider.
 *
 * Kept so existing imports of `useFeature` / `useFeatures` keep working.
 */
import React from 'react';

export { useFeature, useFeatures } from './BootstrapProvider';

export default function FeaturesProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
